
import { ref } from '@vue/composition-api';
import { Modal, Popover } from '05-ui-kit';
import type { Availability } from '~/type/product/Product';
import AvailabilityContent from '~/components/AvailabilityContent/AvailabilityContent.vue';
const __sfc_main = {};
__sfc_main.props = {
  availability: {
    key: "availability",
    required: true,
    type: Array
  },
  placement: {
    key: "placement",
    required: false,
    type: String,
    default: 'left'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const show = ref(false);
  return {
    show
  };
};
__sfc_main.components = Object.assign({
  Popover,
  AvailabilityContent,
  Modal
}, __sfc_main.components);
export default __sfc_main;
